<template>
  <div style="height: calc(8vh)">
  </div>
</template>

<script>
export default {
  name: "HeaderLanding",
};
</script>